//      
import ReactGA from "react-ga4";
                                                    
import BaseTracker from "./BaseTracker";

export default class GoogleTracker extends BaseTracker                     {
	constructor(trackingIds          , withEcommerce          = false, dealerId         = "unknown", dealerName         = "unknown", customerNo         = "unknown") {
		super(trackingIds[0], withEcommerce);
		const gtagOptions = {
			"dimension1": dealerId,
			"dimension2": dealerName,
			"dimension3": customerNo,
		};

		ReactGA.initialize(trackingIds
				.map(id => ({
					trackingId: id,
					gaOptions: {},
					gtagOptions
				})),
			{
				testMode: false,
			}
		);
	}

	handleGenericEvent(cat        , action        , label     ) {
		ReactGA.event(action, {
			category: cat,
			label: label,
			event_label: label,
			event_source: "UCL"
		});
	}

	handleViewItemEvent(product     ) {
		ReactGA.gtag("event", "view_item", {
			items: [{
				item_id: product.id,
				item_name: product.name,
				price: product.price,
				event_source: "UCL"
			}]
		});
	}

	handleSearchEvent(searchTerm        ) {
		if (!searchTerm) return;

		ReactGA.gtag("event", "search", {
			search_term: searchTerm,
			event_source: "UCL"
		});
	}

	handleAddToCartEvent(product     ) {
		ReactGA.gtag("event", "add_to_cart", {
				items: [{
					item_id: product.id,
					item_name: product.name,
					price: product.price,
					event_source: "UCL"
				}]
			});
	}
	handleRemoveFromCartEvent(product     ) {
		ReactGA.gtag("event", "remove_from_cart", {
			items: [{
				item_id: product.id,
				item_name: product.name,
				price: product.price,
				event_source: "UCL"
			}]
		});
	}


}
